import { useEffect, useCallback } from 'react';

export default function usePreventReload(isPrevent: any) {
    const preventReload = useCallback((event: any) => {
        event.preventDefault();
        event.returnValue = '';
    }, []);

    useEffect(() => {
        if (isPrevent) {
            window.addEventListener('beforeunload', preventReload);
        }
        return () => {
            if (isPrevent) {
                window.removeEventListener('beforeunload', preventReload);
            }
        };
    }, [isPrevent, preventReload]);
}
